import config from '~/config';
import { CountryCodeValue } from '~/types/localization/localizationHelperTypes';

export const hasNativeRouteRedirection = (countryCode: CountryCodeValue) => {
  return config.ENABLE_NATIVE_ROUTING[countryCode];
};
